module.exports = __webpack_public_path__ + "static/media/tile-light.28274225.webp";